import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export var ObjectFieldTemplate = function (_a) {
    var properties = _a.properties;
    return _jsx(_Fragment, { children: properties.map(function (element) { return element.content; }) });
};
